// extracted by mini-css-extract-plugin
export default {"root":"FlexColumn_root__qZqjO"};